import { Injectable } from "@angular/core";
import { DECLARATIONGROUP } from "app/model/declarationgroup.model";
import { SharedPdfService } from "app/services/shared/shared-pdf.service";

@Injectable()
export class DECLARATIONService {
  constructor(
    private sharedPdfService:SharedPdfService
  ) {}

  generateDeclartion(declarationGroup: DECLARATIONGROUP) {
    return {
      style: "tableExample",
      table: {
        widths: ["50%", "25%", "25%"],
        body: [
          [{text:"Name:",style: "questions"}, { colSpan: 2, text: "Position:",style: "questions" }, ""],

          [
            { text: " " + declarationGroup.in_declare_name, italics: true },
            {
              colSpan: 2,
              text: " " + declarationGroup.in_declare_position,
              italics: true
            },
            ""
          ],
          [{text:"Signature:",style: "questions"}, { colSpan: 2, text: "Date:",style: "questions" }, ""],

          [
            { text: " " + declarationGroup.in_declare_path, italics: true },
            {
              colSpan: 2,
              text: " " + this.sharedPdfService.dateformat(declarationGroup.in_declare_date),
              italics: true
            },
            ""
          ]
        ]
      }
    };
  }


}



// WEBPACK FOOTER //
// ./src/app/services/pdf/declarationpdf.generation.ts